import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';
import { OutboxTypeEnum } from '../enums/outbox-type.enum';

/**
 * Outbox filters
 */
export class OutboxFilters extends ApiRequestFilters {
	/**
	 * Tenant IDs
	 */
	tenants?: number[];

	/**
	 * User IDs
	 */
	users?: number[];

	/**
	 * Outbox type values
	 */
	types?: OutboxTypeEnum[];

	/**
	 * Data dispatch channel values
	 */
	channels?: DataDispatchChannelEnum[];

	/**
	 * Outbox message status values
	 */
	statuses?: OutboxStatusEnum[];

	/**
	 * Record category enum values
	 */
	subjects?: AppSubjectEnum[];
}
